import { useState } from "react";

export default function useSort() {

    const [state, setState] = useState({});
  
    const [sortDirectionMap, setSortDirectionMap] = useState<any>({});
  
    const getSortDirection = (property : string) => {
      let sortMap;
      if(!sortDirectionMap[property]) { 
        sortMap = sortDirectionMap;
        sortMap[property] = 'DESC';
        setSortDirectionMap(sortMap)
        return 'DESC';
      } 
  
      const sortDirection = sortDirectionMap[property] === 'DESC' ? 'ASC': 'DESC';
      sortMap = sortDirectionMap;
      sortMap[property] = sortDirection;
      setSortDirectionMap(sortMap);
      return sortDirection;
  
    }
  
    const update = (property: string) => {
      setState({sort: {property:property, direction: getSortDirection(property)}});
    }
  
    return {state, update}
  
  }
  